@if (activeBehavior) {
  <div>{{ activeBehavior.name }}</div>
} @else {
  -
}
